<template>
    <div style="min-width: 1200px;">
        <div class="bgcFFF boxShadow1" >
            <div class="container flex items-center justify-between" style="height: 60px;"> 
                <el-image class="cursor-pointer" :src="require('@/assets/home/nav_logo.png')" style="width: 107px; height: 40px;" @click="go_route('/')"></el-image>
                <div class="flex items-center justify-between">
                    <div class="flex items-center font16 flex-1 justify-end">
                        <div class="linkHover marginL20 marginR20 cursor-pointer" @click="go_route('/')">首页</div>
                        <el-popover placement="bottom" trigger="click" popper-class="small-popover" v-for="item in menuList" :key="item.id" >
                            <span slot="reference" >
                                <div class="linkHover marginL15 marginR15 cursor-pointer" :class="activeNav.includes(item.id)? 'active_menu':''">
                                    {{ item.meta.title }} <span class="el-icon-arrow-down"></span>
                                </div>
                            </span>
                            <div :class="item.id == 2000? 'flex':''">
                                <div  v-for="items in item.children" :key="items.id">
                                    <div class="menuLi" v-if="item.id != 2000" @click="menu_route(items)" :class="activeNav.includes(items.id) || activeMenuId ==items.id?'active_menu':''">
                                        <icon  v-if="items.isOpen" icon="si:layers-line" class="svg-icon colorDanger marginR5"></icon>
                                        <icon v-else icon="mingcute:external-link-line" class="svg-icon colorDanger marginR5"></icon>
                                        {{ items.meta.title }}
                                    </div>
                                    <div v-if="item.id == 2000" class="menuLi marginR10 marginL10 marginB10" style="border-bottom: 1px solid #ED1D24;">
                                        {{ items.meta.title }}
                                    </div>
                                    <el-row style="max-width: 240px;">
                                        <el-col :span="24" v-for="itemss in items.children" :key="itemss.id" v-if="!itemss.hidden">
                                            <div class="menuLi paddingT10 paddingB10" @click="menu_route(itemss)" :class="activeNav.includes(itemss.id) || activeMenuId ==itemss.id?'active_menu':''">
                                                <icon  v-if="itemss.isOpen" icon="si:layers-line" class="svg-icon colorDanger marginR5"></icon>
                                                <icon v-else icon="mingcute:external-link-line" class="svg-icon colorDanger marginR5"></icon>
                                                {{ itemss.meta.title }}
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="flex items-center" style="width:380px;position: relative;">
                        <el-input size="small" v-model="searchForm.search" placeholder="请输入搜索内容" style="width: calc(100% - 33px);">
                            <el-select v-model="searchForm.searchId" slot="prepend" placeholder="请选择" style="width: 160px;">
                                <el-option v-for="item in searchType" :key="item.id" :label="item.name" :value="item.id"/>
                            </el-select>
                        </el-input>
                        <div class="bgcRed colorFFF text-center cursor-pointer" style="width: 35px;height: 32px; line-height: 35px;position: absolute;right: 0;" @click="go_search()">
                            <span class="el-icon-search font18"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name:'',
        props:[''],
        data () {
            return {
                searchForm:{
                    search:'',
                    searchId:'',
                },
            }
        },
        components: {},
        computed: {
            menuList(){//路由菜单
                return this.$store.state.route.menuList
            },
            activeNav(){//当前激活的导航
                return this.$store.state.route.activeNav
            },
            activeMenuId(){//当前激活的路由菜单
                return this.$store.state.route.activeMenuId
            },
            searchId(){
                return this.$store.getters.searchId
            },
            keywords(){
                return this.$store.getters.keyWords
            },
            searchType(){
                return this.$store.getters.searchType
            },
        },
        beforeMount() {},
        mounted() {
            this.searchForm.searchId = Number(this.$route.query.searchId)|| ''
            this.searchForm.search = this.$route.query.search
            this.$store.dispatch('search/set_keywords',this.searchForm.search)
            this.$store.dispatch('search/set_searchId',this.searchForm.searchId)
            this.$store.dispatch('route/set_active_route',this.$route.path)
            this.set_searchType()
        },
        methods: {
            menu_route(route){
                if(route.isOpen){

                }else{
                    let routeQuery = {
                        type:route.type,
                    }
                    this.$store.dispatch('route/set_active_route',route.path) //设置激活菜单项
                    this.$router.push({path:route.path,query:routeQuery})
                }
            },
            go_route(path){//跳转本地页面
                this.$router.push({path:path})
            },
            set_searchType(){
                let routePath = this.$route.path
                if(routePath == '/buyer_factory_sourcing' || routePath =='/factory_sourcing'){//找加工厂
                    this.searchForm.searchId = 1
                    this.$store.dispatch('search/set_searchId',1)
                }else if(routePath == '/supplier_sourcing' || routePath =='/buyer_supplier_sourcing'){//找供应商
                    this.searchForm.searchId = 2
                    this.$store.dispatch('search/set_searchId',2)
                }else if(routePath == '/factory_products' || routePath =='/buyer_factory_products'){//找加工厂产品
                    this.searchForm.searchId = 3
                    this.$store.dispatch('search/set_searchId',3)
                }else if(routePath == '/supplier_products' || routePath =='/buyer_supplier_products'){//找供应商产品
                    this.searchForm.searchId = 4
                    this.$store.dispatch('search/set_searchId',4)
                }else if(routePath == '/inquiry'){//询盘
                    this.searchForm.searchId = 5
                    this.$store.dispatch('search/set_searchId',5)
                }else if(routePath == '/equipment_quote'){//仪器设备询价
                    this.searchForm.searchId = 6
                    this.$store.dispatch('search/set_searchId',6)
                }else if(routePath == '/factory_quote'){//铸件机加工询价
                    this.searchForm.searchId = 7
                    this.$store.dispatch('search/set_searchId',7)
                }
            },
            go_search(){
                this.$store.dispatch('search/set_keywords',this.searchForm.search)
                this.$store.dispatch('search/set_searchId',this.searchForm.searchId)
                let routeObj = {
                    search:this.searchForm.search,
                    searchId:this.searchForm.searchId
                }
                if(this.searchForm.searchId == 1){ //跳转我是采购商找加工厂
                    this.$router.push({path:'/buyer_factory_sourcing',query:routeObj})
                }else if(this.searchForm.searchId == 2){//跳转我是加工厂 找供应商
                    this.$router.push({path:'/buyer_supplier_sourcing',query:routeObj})
                }else if(this.searchForm.searchId == 3){//跳转我是采购商 找加工厂产品
                    this.$router.push({path:'/buyer_factory_products',query:routeObj})
                }else if(this.searchForm.searchId == 4){//跳转我是加工厂 找加供应商产品
                    this.$router.push({path:'/buyer_supplier_products',query:routeObj})
                }else if(this.searchForm.searchId == 5){//跳转我是加工厂 卖家 询盘
                    this.$router.push({path:'/inquiry',query:routeObj})
                }else if(this.searchForm.searchId == 6){//跳转我是供应商 仪器设备询价
                    this.$router.push({path:'/equipment_quote',query:routeObj})
                }else if(this.searchForm.searchId == 7){//跳转我是加工厂 铸件机加工询价
                    this.$router.push({path:'/factory_quote',query:routeObj})
                }
            },
            
        },
    }

</script>

<style lang='scss' scoped>
.active_menu{
    color: #ED1D24;
}
.menuLi{
    padding:0.8rem 1.5rem;
    cursor: pointer;
    font-weight: 500;
    font-size: 1.6rem;
    &:hover{
        color: #ED1D24;
    }
}
::v-deep .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>